import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/qweather-icons/icons/100.svg';
const _hoisted_1 = {
  class: "container mt-1 navbar-collapse collapse justify-content-center gap-sm-1",
  id: "header"
};
const _hoisted_2 = {
  class: "d-flex flex-sm-column align-items-center"
};
const _hoisted_3 = {
  class: "m-0"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", {
  class: "m-0"
}, "Weather", -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  fill: "#1C242C",
  alt: "QWeather",
  width: "32",
  height: "32"
}, null, -1);

import { onMounted, onUnmounted } from 'vue'; // onMounted(() => {
//   console.log('天气挂载了');
// });
// onUnmounted(() => {
//   console.log('天气销毁了');
// });

export default {
  __name: 'WeatherHeader',

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$globalParams.cityName), 1), _hoisted_4]), _hoisted_5]);
    };
  }

};